import request from '../untils/request';

const accountApi = {
  list: '/api/ntripaccount/page', // 列表
  add: '/api/ntripaccount/add', // 新增
  update: '/api/ntripaccount/update', // 修改
  view: '/api/ntripaccount/get/', // 查看
  batchdelete: '/api/ntripaccount/delete/batch', // 批量删除
  gethistorytrack: 'api/track/list', // 历史轨迹
  getbdmappoint: 'api/convert/wgs2bd', // 获取百度地图的坐标点

  // list: '/api/equipmentUser/page', // 列表
  // add: '/api/equipmentUser/add', // 新增
  // update: '/api/equipmentUser/update', // 修改
  // view: '/api/equipmentUser/get/', // 查看
  // delete: '/api/equipmentUser/delete/{id}', // 删除
  // batchdelete: '/api/equipmentUser/delete/batch', // 批量删除
  bindornot: '/api/equipmentUser/bindOrNot', // 绑定/解绑
  batchunbind: '/api/equipmentUser/unbind/batch', // 批量解绑
  getmountpoint: '/api/mountPoint/listWithNoSetting', // 获取挂载点列表
  getcurlocation: 'api/newDevicedata/list', // 获取最新位置x
  getrealtimetrack: 'api/newDevicedata/list', // 实时轨迹
  // gethistorytrack: 'api/surfDevicedata/getByEquipmentUserId', // 历史轨迹
};

export function getList(param) {
  // console.log('accountApi---getlist--');
  return request({
    url: accountApi.list,
    method: 'get',
    params: param,
    // headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });
}

export function addAccount(param) {
  // console.log('accountApi---add--', parameter);
  return request({
    url: accountApi.add,
    method: 'post',
    data: param,
  });
}

export function updateAccount(param) {
  // console.log('accountApi---update--', parameter);
  return request({
    url: accountApi.update,
    method: 'put',
    data: param,
  });
}

export function deleteAccount(param) {
  // console.log('accountApi---delete--', parameter);
  return request({
    url: accountApi.batchdelete,
    method: 'delete',
    params: param,
  });
}

export function viewAccount(param) {
  // console.log('accountApi---view--', param);
  return request({
    url: accountApi.view + param.id,
    method: 'get',
  });
}

// 解绑
export function unbindAccount(param) {
  // console.log('accountApi---delete--', parameter);
  return request({
    url: accountApi.batchunbind,
    method: 'put',
    params: param,
  });
}

export function getMountPoint() {
  // console.log('accountApi---delete--', parameter);
  return request({
    url: accountApi.getmountpoint,
    method: 'get',
    data: {},
  });
}

export function bindMountPoint(param) {
  // console.log('accountApi---delete--', parameter);
  return request({
    url: accountApi.bindornot,
    method: 'put',
    data: param,
  });
}

export function getCurLoaction(param) {
  // console.log('accountApi---delete--', parameter);
  return request({
    url: accountApi.getcurlocation,
    method: 'get',
    params: param,
  });
}

export function getRealtimeTrack(param) {
  // console.log('accountApi---delete--', parameter);
  return request({
    url: accountApi.getrealtimetrack,
    method: 'get',
    params: param,
  });
}

export function getHistoryTrack(param) {
  // console.log('accountApi---delete--', parameter);
  return request({
    url: accountApi.gethistorytrack,
    method: 'get',
    params: param,
  });
}

export function getbdmapLocation(param) {
  // console.log('accountApi---delete--', parameter);
  return request({
    url: accountApi.getbdmappoint,
    method: 'get',
    params: param,
  });
}
